<template>
  <div class="section py-0 px-5" v-if="site === constante.site && user.agences.length > 1">
    <div class="tile app-title">
      <p class="subtitle is-6">Par agence(s)</p>
    </div>
    <div class="field">
      <b-taginput
        v-model="agencesSelected"
        @typing="getFilteredAgenceTags"
        @input="agencesChange"
        :data="agenceTags"
        type="is-primary"
        field="libelleAgence"
        autocomplete
        open-on-focus>
      </b-taginput>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import cloneDeep from 'lodash/cloneDeep';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const User = createNamespacedHelpers('user');

export default {
  name: 'agence',
  data() {
    return {
      agenceTags: null,
      constante: {
        site: 'sopa',
      },
      agencesSelected: [],
    };
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
      site: 'site',
    }),
  },
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setAgences: types.SET_AGENCES_SELECTIONNEES,
    }),
    ...VenteReseauxTempo.mapActions({
      actionRechercheReseaux: 'rechercheReseaux',
    }),
    rechercheVentesReseaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionRechercheReseaux().then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des réseaux tempos', e);
      });
    },
    getFilteredAgenceTags(text) {
      const agences = this.user.agences.filter((agence) => {
        return agence.libelleAgence.toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
      this.agenceTags = agences;
    },
    getAgenceTag() {
      this.agenceTags = this.agenceTags.filter((agence) => {
        return !this.agencesSelected.map(a => a.agenceId)
          .includes(agence.agenceId);
      });
    },
    agencesChange(value) {
      this.setAgences(value);
      setTimeout(() => {
        this.rechercheVentesReseaux();
      }, 2000);
    },
  },
  mounted() {
    this.agenceTags = cloneDeep(this.user.agences);
    if (this.agenceTags) {
      this.agencesSelected = this.agenceTags.filter((el) => {
        return el.agenceId === this.user.agenceId;
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/filtres/agence.vue